module.exports = __webpack_public_path__ + "img/coupon_img2.c17ab6a2.png";